import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/authcontext";
import { useTenantRole } from "./TenantRoleDisplay";


const AccessDenied: React.FC = () => {
  const navigate = useNavigate();
  const { selectedTenantId } = useContext(AuthContext);
  const role = useTenantRole(selectedTenantId || "");

  const handleGoHome = () => {
    if (!role) {
      navigate("/dashboard/crm-dashboard", { replace: true });
      return;
    }

    if (
      role.role_key === "SUPERADMIN" ||
      role.role_key === "PLATFORM_ANALYST"
    ) {
      navigate("/dashboard/crm-dashboard", { replace: true });
    } else {
      navigate("/dashboard/crm-dashboard", { replace: true });
    }
  };

  return (
    <div className="d-flex align-items-center justify-content-center min-vh-100">
      <div className="text-center">
        <div className="mb-4">
          <i
            className="fas fa-ban"
            style={{ fontSize: "5rem", color: "#dc3545" }}
          ></i>
        </div>
        <h1 className="display-4 fw-bold text-danger mb-3">Access Denied</h1>
        <p className="lead mb-4">
          You don't have permission to access this page. {<br />} Your current
          role doesn't allow access to this page.
        </p>
        <button className="btn btn-primary btn-lg" onClick={handleGoHome}>
          <i className="fas fa-home me-2"></i>
          Go to Home Page
        </button>
      </div>
    </div>
  );
};

export default AccessDenied;
